import React, { useState, useEffect } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import { Form, Button, Container } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";
import NavbarIndex from "../../components/NavbarIndex";
import { useLang } from "../../contexts/LanguageContext";
import Footer from "../../components/Footer";
import { saveUserApi } from "../../api/fetchWithAuth";
import { getLanguageAndRegion } from "../../utils/languageUtils";

import './Login.css';
import login_image from '../../images/login_image.png';

export default function Register() {
  const { t } = useLang();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // navigate("/home");
    }
  }, [user, navigate]);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const { language: nativeLanguage, region: nativeRegion } = getLanguageAndRegion(); // Get language and region

      // Save the user in the API
      await saveUserApi(
        {
          uid: user.uid,
          email: user.email,
          firstName,
          lastName,
          nativeLanguage,
          nativeRegion,
        },
        user
      );

      navigate("/home");
    } catch (err) {
      switch (err.code) {
        case "auth/email-already-in-use":
          setError(t("REGISTER_ERROR_EMAIL_ALREADY_IN_USE"));
          break;
        case "auth/invalid-email":
          setError(t("REGISTER_ERROR_INVALID_EMAIL"));
          break;
        case "auth/weak-password":
          setError(t("REGISTER_ERROR_WEAK_PASSWORD"));
          break;
        default:
          setError(t("REGISTER_ERROR_DEFAULT"));
      }
    }
  };

  return (
    <>
      <div className="background" style={{backgroundSize: "cover"}}>
        <Container> 
          <NavbarIndex login_button={false} />
          <Container className="login-container">
            <div className="login-board text-center">
              <img className="mx-auto d-block" src={login_image} alt="login_image" />
              <h2>{t("REGISTER_TITLE")}</h2>
              {error && <p className="login-error">{error}</p>}
              <Form onSubmit={handleRegister}>
                <Form.Group className="mb-3 form-floating">
                  <Form.Control
                    type="text"
                    id="floatingFirstName"
                    placeholder="Nombre"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                  <Form.Label htmlFor="floatingFirstName">{t("REGISTER_FIRST_NAME")}</Form.Label>
                </Form.Group>
                <Form.Group className="mb-3 form-floating">
                  <Form.Control
                    type="text"
                    id="floatingLastName"
                    placeholder="Apellido"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                  <Form.Label htmlFor="floatingLastName">{t("REGISTER_LAST_NAME")}</Form.Label>
                </Form.Group>
                <Form.Group className="mb-3 form-floating">
                  <Form.Control
                    type="email"
                    id="floatingEmail"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <Form.Label htmlFor="floatingEmail">{t("REGISTER_EMAIL")}</Form.Label>
                </Form.Group>
                <Form.Group className="mb-3 form-floating">
                  <Form.Control
                    type="password"
                    id="floatingPassword"
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <Form.Label htmlFor="floatingPassword">{t("REGISTER_PASSWORD")}</Form.Label>
                </Form.Group>
                <Button type="submit" className="mt-3" variant="success">
                {t("REGISTER_BUTTON")}
                </Button>
              </Form>
              
              <hr />
              <p className="mt-3">
               {t("REGISTER_HAVE_ACCOUNT")} <a href="/login">{t("REGISTER_LOGIN")}</a>
              </p>

              </div>
          </Container>
        </Container>
      </div>
      <div className="p-5"></div>
      <Footer />
    </>
  );
}
